export const HELP_SITE_ORIGIN = "https://help.proffitel.ru";

const HELP_ROUTES = [
  { exact: "/", path: "/glavnaya/" },
  { prefix: "/hub/numbers", path: "/upravlenie-nomerami/" },
  { prefix: "/hub/dialogs", path: "/dialogi/" },
  { prefix: "/hub/warehouse", path: "/sklad/" },
  { prefix: "/hub/nutrition", path: "/pitanie/" },
  { prefix: "/hub/health", path: "/lechenie/" },
  { prefix: "/hub/service", path: "/servis/" },
  { prefix: "/hub/sprs", path: "/spravochniki/" },
  { prefix: "/hub/help", path: "/pomoshch/" },
  { prefix: "/doc/exp", path: "/putevki/" },
  { prefix: "/doc/plat", path: "/platezhi/" },
  { prefix: "/bron", path: "/shahmatka/" },
  { prefix: "/spr/number-cat", path: "/kategorii-nomerov/" },
  { prefix: "/spr/number-spr", path: "/spravochniki/dopolnitelnye/" },
  { prefix: "/spr/number", path: "/nomera/" },
  { prefix: "/number/price", path: "/prajsy/" },
  { prefix: "/dialogs/channels", path: "/dialogi/kanaly/" },
  { prefix: "/dialogs/agents", path: "/dialogi/agenty/" },
  { prefix: "/dialogs", path: "/dialogi/zhurnal/" },
  { prefix: "/warehouse/documents", path: "/sklad/nakladnye/" },
  { prefix: "/warehouse/register", path: "/sklad/ostatki/" },
  { prefix: "/warehouse/product-card", path: "/sklad/kartochka-tovara/" },
  { prefix: "/warehouse/movements", path: "/sklad/dvizheniya/" },
  { prefix: "/warehouse", path: "/sklad/" },
  { prefix: "/nutrition/templates", path: "/pitanie/shablony-menyu/" },
  { prefix: "/nutrition/map", path: "/pitanie/karta-pitaniya/" },
  { prefix: "/nutrition/register", path: "/pitanie/registraciya/" },
  { prefix: "/nutrition/tables", path: "/pitanie/zaly/" },
  { prefix: "/nutrition/cost", path: "/pitanie/stoimost/" },
  { prefix: "/nutrition", path: "/pitanie/" },
  { prefix: "/health/clients", path: "/lechenie/klienty/" },
  { prefix: "/spr/zal", path: "/lechenie/kabinety/" },
  { prefix: "/service/check-db", path: "/servis/proverka-bazy/" },
  { prefix: "/service/reports", path: "/servis/otchety/" },
  { prefix: "/service/monitor", path: "/servis/monitor/" },
  { prefix: "/service/settings", path: "/servis/nastroyki/" },
  { prefix: "/service", path: "/servis/" },
  { prefix: "/spr/sotr", path: "/spravochniki/sotrudniki/" },
  { prefix: "/spr/tov", path: "/spravochniki/uslugi/" },
  { prefix: "/spr/pred", path: "/spravochniki/kontragenty/" },
  { prefix: "/spr/template-nazn", path: "/spravochniki/shablony-naznacheniy/" },
  { prefix: "/spr/text", path: "/spravochniki/shablony/" },
  { prefix: "/spr/holidays", path: "/spravochniki/prazdniki/" },
  { prefix: "/spr/kassa", path: "/spravochniki/kassy/" },
  { prefix: "/spr/servis", path: "/spravochniki/diagnosy/" },
  { prefix: "/spr/status", path: "/spravochniki/statusy/" },
  { prefix: "/spr/cards", path: "/spravochniki/karty/" },
  { prefix: "/help/about", path: "/pomoshch/" }
];

const normalizePathname = (pathname) => {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "") || "/";
};

export function getHelpPath(pathname) {
  const current = normalizePathname(pathname);
  for (const route of HELP_ROUTES) {
    if (route.exact && current === route.exact) return route.path;
    if (route.match && route.match(current)) return route.path;
    if (route.prefix && (current === route.prefix || current.startsWith(`${route.prefix}/`))) {
      return route.path;
    }
  }
  return null;
}

export function toHelpUrl(path) {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${HELP_SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}

export function getHelpUrl(pathname, topic) {
  return toHelpUrl(topic || getHelpPath(pathname) || "/pomoshch/");
}

export function openHelpUrl(url) {
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
}
